import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IOSModal } from './ios/IOSModal';
import { useAuth } from '../../../lib/auth/AuthProvider';

interface AnonymousLogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * 匿名用户退出确认模态框
 * 提供三个选项：取消退出、前往绑定、退出并删除
 */
export const AnonymousLogoutModal: React.FC<AnonymousLogoutModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation(['v3/common', 'v3/me']);
  const { signOut } = useAuth();
  const navigate = useNavigate();

  // 前往绑定页面
  const handleGoToBinding = () => {
    onClose();
    navigate('/v3/me'); // 假设绑定功能在 Me 页面
  };

  // 退出并删除数据
  const handleDeleteAndLogout = async () => {
    try {
      // TODO: 这里可以添加删除用户数据的逻辑
      // await deleteAnonymousUserData();
      
      await signOut();
      onClose();
    } catch (error) {
      console.error('退出失败:', error);
      // 即使出错也要关闭模态框
      onClose();
    }
  };

  return (
    <IOSModal
      isOpen={isOpen}
      onClose={onClose}
      title="⚠️ 退出匿名账户"
      buttons={[
        {
          text: '前往绑定 (推荐)',
          onClick: handleGoToBinding,
          variant: 'primary'
        },
        {
          text: '取消退出',
          onClick: onClose,
          variant: 'secondary'
        },
        {
          text: '退出并删除',
          onClick: handleDeleteAndLogout,
          variant: 'danger'
        }
      ]}
    >
      <p className="text-ios-body text-ios-gray dark:text-ios-dark-gray text-center">
        {t('v3/auth:logout.anonymousWarning', '退出后将永久删除所有数据，且无法重新登录此账户。')}
      </p>
    </IOSModal>
  );
};
